(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/kung-keno-toggle.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/kung-keno-toggle.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.kung_keno_toggle = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form/label",{"name":"ui","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":8,"column":101}}})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Kung Keno "
    + container.escapeExpression((lookupProperty(helpers,"tb-ui")||(depth0 && lookupProperty(depth0,"tb-ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"svg",{"name":"tb-ui","hash":{"class":"kung-keno-checkbox-icon","svg":"kungkeno"},"data":data,"loc":{"start":{"line":8,"column":32},"end":{"line":8,"column":94}}}));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||alias2).call(alias1,"form/checkbox",{"name":"ui","hash":{"branding":(lookupProperty(helpers,"brandingClass")||(depth0 && lookupProperty(depth0,"brandingClass"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"productId") : depth0),{"name":"brandingClass","hash":{},"data":data,"loc":{"start":{"line":6,"column":11},"end":{"line":6,"column":36}}}),"checked":(depth0 != null ? lookupProperty(depth0,"hasKungKeno") : depth0),"value":123,"name":"kung-keno-toggle","class":"js-kung-keno-toggle"},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":9,"column":7}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['components-numbergames-game-kung_keno_toggle'] = svs.numbergames.game.templates.kung_keno_toggle;
})(svs, Handlebars);


 })(window);